// Prices and quantities as plain text: a price is always readable as "2,500 Gems", never an image, and a sale is
// said in words (the old price is struck through and read out as "Was").
import { Icon } from "../../icons";
import { CURRENCY_NAME, type Currency } from "./storeSite";

const grouped = (amount: number) => new Intl.NumberFormat().format(amount);

export function PriceTag({ currency, amount, was }: { currency: Currency; amount: number; was?: number | null }) {
  return <span className={`price ${was ? "on-sale" : ""}`}>
    <b>{grouped(amount)}</b> <span className="price-currency">{CURRENCY_NAME[currency]}</span>
    {was ? <s><span className="sr-only">Was </span>{grouped(was)}</s> : null}
  </span>;
}

export function QuantityStepper({ value, max, onChange, label, disabled }: { value: number; max: number; onChange: (value: number) => void; label: string; disabled?: boolean }) {
  return <div className="stepper" role="group" aria-label={label}>
    <button type="button" className="icon-button" aria-label="Decrease quantity" disabled={disabled || value <= 1} onClick={() => onChange(value - 1)}><Icon name="minus" size={16}/></button>
    <output aria-live="off">{value}</output>
    <button type="button" className="icon-button" aria-label="Increase quantity" disabled={disabled || value >= max} onClick={() => onChange(value + 1)}><Icon name="plus" size={16}/></button>
  </div>;
}
